export const ROLES = {
    ADMIN: { label: "Admin", value: 99 },
    THERAPIST: { label: "Therapist", value: 2 },
    CUSTOMER: { label: "Customer", value: 1 },
    GUEST: { label: "Guest", value: 0 },


}
